/*
 * @Author: Kida
 * @Date: 2020-11-15 23:30:42
 * @LastEditTime: 2021-07-07 16:07:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\config.js
 */

import * as THREE from 'three'
import TWEEN from 'tween.js'

export const config = {
  Map: {
    Token: '4996ac21352cc9d04b23813a4960c1e0'
  },

  GodMode: {
    MinLat: 31,
    FadeRecoverDelay: 100,
    FadeAllTime: 2000,

    PanningLimit: 100000
  },

  PanoMode: {
    FadeRotateDist: 5,
    FadeRecoverDelay: 100,
    FadeAllTime: 3000,

    TransitionTime: 2000,
    LookToTime: 3000
  },

  Material: {
    WaitForLoadDelay: 400
  },

  CPoint: {
    NormalOpacity: 0.5,
    ActiveOpacity: 0.8,
    DistMax: 16777215
  },

  Cursor: {
    InteractMaxDist: 1750
  },

  Interact: {
    MaxDistSqr: 1750 * 1750,
    MaxDeg: Math.PI / 4,
    NeighbourRadius: 5000
  },

  Hotpoint: {
    TextureScale: new THREE.Vector3(400, 400, 1),

    NoSizeScale: new THREE.Vector3(0.005, 0.005, 1),
    SizeScale: new THREE.Vector3(10, 10, 10),

    AnimationWatiTime: 5000,
    AnimationIntervalTime: 5000,
    InconAnimationFrame: 3,

    MinDist: 1000
  },

  BuildingTag: {
    Scale: new THREE.Vector3(0.1, 0.03, 0.1)
  },

  Mode: {
    isDebug: false
  },

  SingleView: {
    CameraPosition: new THREE.Vector3(),
    Matrix: new THREE.Matrix4().identity()
  },
  hostAddress: {
    // rootIp: process.env.NODE_ENV === 'production' ? '/dist/play' : 'http://124.71.113.79/play'
    // rootIp: process.env.NODE_ENV === 'production' ? 'http://124.71.113.79/dist/play' : 'http://localhost:8080/play'
    // rootIp: `${window.location.protocol}//${window.location.host}/play`
    rootIp: `${window.location.protocol}//${window.location.host}/admin/play`
  },
  Stastics: {
    WaitTime: 10
  },
  Damping: {
    distance: 0.5,
    time: 2500,
    easingFunction: TWEEN.Easing.Sinusoidal.Out
  },
  Default: {
    LocationIcon: '/data/public/location_512x512.png'
  }
}
